module.exports = __webpack_public_path__ + "static/media/outside5.9e3e4f33.png";